var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticClass:"subscription",attrs:{"xs12":""}},[_vm._v("\n  E-Komics subscription is not available in your region.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }